import { useState } from "react";
import Icon from "@mdi/react";
import { mdiMagnify, mdiClose } from "@mdi/js";
import "./SearchBar.scss";

const SearchBar = ({ value, onChange, placeholder = "Search..." }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleClear = () => {
    onChange("");
  };

  return (
    <div className={`search-bar ${isFocused ? "focused" : ""} ${value ? "has-value" : ""}`}>
      <Icon path={mdiMagnify} size={0.9} className="search-bar__icon" />
      <input
        type="text"
        className="search-bar__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      {value && (
        <button
          className="search-bar__clear"
          onClick={handleClear}
          type="button"
        >
          <Icon path={mdiClose} size={0.8} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;

